import api from '../utils/apiUtils';

const API_URL = '/audio-content/';

const METADATA_URL = '/metadata/';

export const fetchAllMetadata = async () => {
  try {
    const resp = await api.post(METADATA_URL + 'list-all-metadata', {});
    const metadata = resp.data;
    return metadata;
  } catch (error) {
    console.error('Error fetching metadata:', error);
    throw error;
  }
}



// Fetch all audios
export const fetchAudio = async () => {
  try {
    const resp = await api.post(API_URL + 'list-audio-content', {});
    const videos = resp.data
    console.log(videos);
    return videos;
  } catch (error) {
    console.error('Error fetching audios:', error);
    throw error;
  }
};



// Fetch daily audio
export const fetchDailyAudio = async () => {
  try {
    const allAudios = await fetchAudio();
    const randomAudio = allAudios[Math.floor(Math.random() * allAudios.length)];
    return randomAudio;
  } catch (error) {
    console.error('Error fetching daily audio:', error);
    throw error;
  }
};

// Get audio by ID
export const fetchAudioById = async (id) => {
  try {
    const allAudios = await fetchAudio();
    const audio = allAudios.find(a => a.id === id);
    if (audio) {
      return audio;
    } else {
      throw new Error('Video not found');
    }
  } catch (error) {
    console.error('Error fetching audio by ID:', error);
    throw error;
  }
};

// Helper function to parse comma-separated values or return array as-is
const parseCommaSeparated = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string') {
    return value.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }
  return [];
};

// Filter audios
export const filterAudio = (audios, searchTerm = '', chakraFilter = '', emotionFilter = '', categoryFilter = '') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let filtered = audios;
      
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter(audio => {
          const chakras = parseCommaSeparated(audio.chakras);
          const emotions = parseCommaSeparated(audio.emotions);
          const tags = parseCommaSeparated(audio.tags || '');
          
          return audio.title.toLowerCase().includes(term) ||
                 audio.excerpt.toLowerCase().includes(term) ||
                 audio.fullContent.toLowerCase().includes(term) ||
                 chakras.some(chakra => chakra.toLowerCase().includes(term)) ||
                 emotions.some(emotion => emotion.toLowerCase().includes(term)) ||
                 tags.some(tag => tag.toLowerCase().includes(term));
        });
      }
      
      if (chakraFilter) {
        filtered = filtered.filter(audio => {
          const chakras = parseCommaSeparated(audio.chakras);
          return chakras.includes(chakraFilter);
        });
      }
      
      if (emotionFilter) {
        filtered = filtered.filter(audio => {
          const emotions = parseCommaSeparated(audio.emotions);
          return emotions.includes(emotionFilter);
        });
      }
      
      if (categoryFilter) {
        filtered = filtered.filter(audio => {
          return audio.categoryName === categoryFilter;
        });
      }
      
      resolve(filtered);
    }, 400);
  });
};

// Get unique chakras and emotions for filter options
export const getFilterOptions = (audios) => {
  const allChakras = new Set();
  const allEmotions = new Set();
  
  audios.forEach(audio => {
    const chakras = parseCommaSeparated(audio.chakras);
    const emotions = parseCommaSeparated(audio.emotions);
    
    chakras.forEach(chakra => allChakras.add(chakra));
    emotions.forEach(emotion => allEmotions.add(emotion));
  });
  
  return {
    chakras: Array.from(allChakras).sort(),
    emotions: Array.from(allEmotions).sort()
  };
}; 